<template>
  <div class="footer">
    <!-- 顶部三个核心模块（地址/二维码/电话） -->
    <div class="footer-main">
      <!-- 左侧：公司地址 -->
      <div class="contact-block">
        <div class="block-title">Head Office</div>
        <div class="block-content">3300 Steeles Ave., West, Unit 16,</div>
        <div class="block-content">Concord, Ontario</div>
        <div class="block-content">L4K 2Y4</div>
      </div>

      <!-- 中间：二维码模块 -->
      <div class="qr-block">
        
        <img 
          src="https://alive-1302662846.cos.ap-nanjing.myqcloud.com/1741324738676./website.png" 
          alt="Scan to get free quote"
        />
        <div class="qr-title">SCAN FOR A FREE QUOTE</div>
      </div>

      <!-- 右侧：联系电话 -->
      <div class="contact-block">
        <div class="block-title">Telephone Numbers</div>
        <div class="block-content">Telephone: 905-738-4076</div>
        <div class="block-content">Toll Free: 1-877-5-Fridge 1-877-537-343</div>
        <div class="block-content">Fax: 905-738-8364</div>
      </div>
    </div>

    <!-- 底部版权信息 -->
    <div class="footer-copyright">
      ©2017 Southern Atlantic Service. All product names, logos, and brands are property of their respective owners
    </div>
  </div>
</template>

<script>
export default {
  name: "PCFooter",
};
</script>

<style scoped>
/* 全局页脚样式 */
.footer {
  width: 100%;
  background-color: #595857;
  color: #fff;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* 顶部核心模块容器：Flex布局实现均匀分布 */
.footer-main {
  display: flex;
  justify-content: space-between; /* 三部分均匀占满宽度 */
  align-items: center; /* 垂直居中对齐 */
  gap: 40px; /* 模块间间隙 */
  max-width: 1200px; /* 限制最大宽度，避免过宽 */
  margin: 0 auto; /* 水平居中 */
  padding: 40px 20px; /* 上下内边距（替代原height） */
}

/* 联系信息块（左侧/右侧通用） */
.contact-block {
  flex: 1; /* 各占1份宽度，保持一致 */
  text-align: center;
}

/* 联系块标题（黄色强调） */
.block-title {
  font-size: 16px;
  font-weight: 600;
  color: #EEB011;
  margin-bottom: 12px;
}

/* 联系块内容（白色正文） */
.block-content {
  font-size: 14px;
  line-height: 1.6; /* 提升可读性 */
  margin-bottom: 8px;
  opacity: 0.9; /* 轻微降低透明度，区分标题 */
}

/* 二维码块样式 */
.qr-block {
  flex: 0.8; /* 占比略小（或固定宽度160px） */
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 二维码标题 */
.qr-title {
  font-size: 18px;
  font-weight: 600;
  color: #EEB011;
  margin-top: 15px;
}

/* 二维码图片 */
.qr-block img {
  width: 160px;
  height: 160px;
  border-radius: 8px;
  object-fit: cover; /* 保持图片比例不变形 */
}

/* 底部版权信息 */
.footer-copyright {
  text-align: center;
  padding: 18px 0;
  font-size: 12px;
  color: #ddd; /* 浅灰降低对比度 */
  border-top: 1px solid rgba(255, 255, 255, 0.1); /* 顶部分割线，区分内容区 */
}

/* 响应式：小屏幕（≤768px）堆叠显示 */
@media (max-width: 768px) {
  .footer-main {
    flex-direction: column; /* 改为垂直排列 */
    gap: 30px; /* 垂直间隙 */
  }

  .contact-block,
  .qr-block {
    width: 100%; /* 占满容器宽度 */
  }
}
</style>